import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CategoryLabels, SubCategoryLabels } from '@admitly/shared';
import { apiGet, apiPatch } from '../lib/api.js';

/** Raw override maps stored on the tenant (defaults are applied elsewhere). */
export type CategoryLabelsSettings = {
  category_labels: CategoryLabels;
  sub_category_labels: SubCategoryLabels;
};

export type UpdateCategoryLabelsPayload = {
  category_labels?: CategoryLabels;
  sub_category_labels?: SubCategoryLabels;
};

export function useCategoryLabels() {
  return useQuery({
    queryKey: ['admin', 'category-labels'],
    queryFn: () => apiGet<CategoryLabelsSettings>('/admin/categories'),
    staleTime: 30_000,
  });
}

export function useUpdateCategoryLabels() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateCategoryLabelsPayload) =>
      apiPatch<CategoryLabelsSettings>('/admin/categories', input),
    onSuccess: (data) => {
      qc.setQueryData(['admin', 'category-labels'], data);
      // The sidebar + search chips read the merged labels from /tenant/categories.
      void qc.invalidateQueries({ queryKey: ['tenant', 'categories'] });
    },
  });
}
